<template>
  <div class="background-03">
    <v-layout row wrap justify-center mt-2 pt-5 class="adorn-bottom">
      <v-flex xs12 sm2 text-xs-right>
        <image-app class="animated fadeInLeft" :imaSize="77" imaSrc="contenido/diapositiva_24" imaAlt="Calculadora para el presupuesto"></image-app>
      </v-flex>
      <v-flex xs12 sm6 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Calculadora de patrimonio" titleLevel="h1">
          <template slot="partOne">Calculadora<br></template>
          <template slot="partTwo">de</template>
          <template slot="partThree"> patrimonio</template>
        </ui-title-one>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center mt-5 pt-5 class="animated fadeInDown dura_2">
    <v-flex xs12 class="text-xs-center">
      <ui-simple-lsc  :vidTittle="'Calculadora de patrimonio'" videoEmbed="ADMINISTRACIONDINERO50CalculadoraDePatrimoniob.mp4"></ui-simple-lsc>
    </v-flex>
      <v-flex xs12 sm8>
        <p>
          Esta herramienta le permitirá determinar cuál es su patrimonio.
          Una vez finalice el curso, encontrará desbloqueada la calculadora
          de <strong>patrimonio</strong> de manera permanente en la sección <strong>Mi perfil</strong> y
          podrá usarla las veces que necesite. También podrá descargar
          la información en formato PDF.
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-50.vue?245af450